<template>
  <div>
    <JumpcloudGoPageLoader :userEmail="userEmail" />
  </div>
</template>

<script>
import { LoginConsts } from 'client/util/Constants';
import { durtApiResponseType } from 'client/services/durtConstants';
import JumpcloudGoPageLoader from 'client/components/JumpcloudGoPageLoader.vue';
import Util from 'client/util/Util';
import api from 'client/api';
import durtService from 'client/services/durtService';
import get from 'lodash/get';
import managedBrowserService from 'client/services/managedBrowserService';
import noop from 'lodash/noop';
import oidcClientService from 'client/services/oidcClientService';
import routerService from 'client/services/routerService';

const { responseMessages } = LoginConsts;
const { user: userApi } = api;

export default {
  name: 'JumpCloudOidcCallback',

  components: {
    JumpcloudGoPageLoader,
  },

  data() {
    return {
      userEmail: '',
    };
  },

  created() {
    const errorCode = this.$route.query.error;
    if (errorCode) {
      const message = responseMessages[errorCode] || responseMessages.unexpected_error;
      routerService.replaceToUserLogin({ params: { error: message } });
    } else {
      this.durtRegister();
    }
  },

  methods: {

    async validateChrome() {
      try {
        await managedBrowserService.validateChrome();
      } catch (e) {
        noop();
      }
    },

    async durtRegister() {
      let userState = '';
      try {
        // in case processSigninResponse fails we will loose the user state
        // should handle the state our selves or we can rely on this
        const oidcResponse = await oidcClientService.processSigninResponse();
        this.userEmail = oidcResponse.profile.email;
        userState = oidcResponse.userState;
        if (!oidcResponse?.id_token) {
          throw new Error('id_token not found in oidc response');
        }
        try {
          await durtService.register(oidcResponse.id_token);
        } catch (registerError) {
          this.reportGoRegistrationFailure(registerError);
          throw registerError;
        }

        await this.validateChrome();
        // Calling getAccess & signin after successful register
        // ensures user session is DURT-derived.
        const accessData = await durtService.getAccess();
        // Wait 2s to allow JCGO animation enough time to render
        await Promise.all([durtService.signin(accessData), Util.delay(1000)]);
        routerService.replaceToUserLogin({
          query: Object.fromEntries(new URLSearchParams(userState).entries()),
        });
      } catch (e) {
        try {
          const { text, logout = false } = JSON.parse(e?.response?.data?.message);
          const query = new URLSearchParams(userState);
          if (logout) {
            // invalidate durt for IdP signin attempts
            await durtService.logout();

            routerService.replaceToUserLogin({
              params: {
                error: text,
              },
              query: Object.fromEntries(query.entries()),
            });
          }
        } catch {
          const errorType = get(e, 'message', durtApiResponseType.unexpectedError);
          let error = 'goError';
          if (typeof errorType === 'string') {
            switch (errorType) {
              case durtApiResponseType.notSupportedError:
                error = 'goUnsupportedError';
                break;
              case durtApiResponseType.deviceUserMismatch:
                error = 'goInvalidCredentialsError';
                break;
              case durtApiResponseType.unexpectedError:
              default:
                error = 'goError';
            }
          }
          const query = new URLSearchParams(userState);
          query.append('error', error);
          // if the user is logged in (which in the normal case he is,
          // because we are the relying party and the authority)
          // the login error won't appear in the notification with code below
          routerService.replaceToUserLogin({
            query: Object.fromEntries(query.entries()),
          });
          // should we show him a warning notification in this page (before redirecting him)
          // and in case he is logged in we can show a continue button
        }
      }
    },

    reportGoRegistrationFailure(error) {
      const reason = get(error, 'message', durtApiResponseType.unexpectedError);
      if (typeof reason !== 'string') {
        return;
      }

      userApi.registrationFailedDURT({ reason }).catch(noop);
    },
  },
};
</script>
